export default __webpack_public_path__ + "static/media/Trying to connect to synced cell phone.16809ad9.svg";